module.exports = __webpack_public_path__ + "img/wangqiu.f7db57f0.jpg";